export default class FloatingActiveFilter {
    init(params) {
        this.eGui = document.createElement('div');
        this.eGui.id = 'floatingActiveFilter'
        this.eGui.innerHTML = "<select class='input form-control form-select checkboxDropdownFilter'> <option value=''>Any</option> <option value='true'>Covering</option> <option value='false'>Not Covering</option> </select>";
        this.currentValue = null;
        this.eFilterInput = this.eGui.querySelector('select');
        this.eFilterInput.style.color = params.color;

        const onInputBoxChanged = () => {
            if (this.eFilterInput.value === '') {
                // Remove the filter
                params.parentFilterInstance((instance) => {
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }

            this.currentValue = 'true' == this.eFilterInput.value;
            params.parentFilterInstance((instance) => {
                instance.onFloatingFilterChanged('equals', String(this.currentValue));
                console.log(instance.getModel())
            });
        };

        this.eFilterInput.addEventListener('input', onInputBoxChanged);
    }

    onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null message her
        if (!parentModel) {
            this.eFilterInput.value = '';
            this.currentValue = null;
        } else {
            this.eFilterInput.value = parentModel.filter + '';
            this.currentValue = parentModel.filter;
        }
    }

    getGui() {
        return this.eGui;
    }
}